<template>
  <div>
    <div class="mt-8 mb-4">
      <div v-for="parentSection in sections" :key="parentSection.title"> 
        <div class="mx-10" :class="{ 'border-polgrey border-b-2 mb-6 sm:pb-6': parentSection.subTitles.length }">
          <h2 class="mb-2 text-2xl leading-7 sm:text-xl sm:leading-9" v-if="parentSection.title && (parentSection.subTitles.length ||  parentSection.questions.length)">
            {{ parentSection.title }}
          </h2>
          <!-- Parent has questions -->
          <template v-if="Array.isArray(parentSection.questions) && parentSection.questions.length">
            <div class="grid flex-row-reverse grid-cols-1 mb-8 overflow-hidden sm:mb-0 md:grid-cols-2" v-for="question in parentSection.questions" :key="question.question">
              <div class="text-lg leading-6 sm:mb-8">
                {{ question.question }}
              </div>
              <div class="border-l-0 border-gray-200 sm:border-t md:border-0 md:border-l-2">
                <div class="px-0 mt-2 sm:mt-0 sm:mb-8 sm:pl-10">
                  <div class="text-lg font-bold leading-6">
                    <span v-if="question.pending" class="text-polorange"> Pending update from branch </span>
                    <span v-else> {{ question.answer }} </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- sub questions -->
          <template v-if="Array.isArray(parentSection.subTitles) && parentSection.subTitles.length">
            <div v-for="subsection in parentSection.subTitles" :key="subsection.title">
              <!-- sub section title -->
              <div class="mt-6 text-lg font-bold leading-6 sm:mb-8 text-pol-sub-heading">
                {{ subsection.title }}
              </div>
              <!-- questions -->
              <div class="grid flex-row-reverse grid-cols-1 mb-8 overflow-hidden sm:mb-0 md:grid-cols-2" v-for="subsectionQuestion in subsection.questions" :key="subsectionQuestion.question">
                <div class="text-lg leading-6 sm:mb-8">
                  {{ subsectionQuestion.question }}
                </div>
                <div class="border-l-0 border-gray-200 sm:border-t md:border-0 md:border-l-2">
                  <div class="px-0 mt-2 sm:mt-0 sm:mb-8 sm:pl-10">
                    <div class="text-lg font-bold leading-6">
                      <span v-if="subsectionQuestion.pending" class="text-polorange"> Pending update from branch </span>
                      <span v-else> {{ subsectionQuestion.answer }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BranchQuestions",
    props: {
      sections: Array
    }
  }
</script>
